/**
 * @Author:
 * @Description:
 * @DateTime: Created in 2021-03-24 19:17:06
 */

import CompareNotice from '../compareNotice';
import { Toast } from 'src/util/toast';
import { default as CellOperate } from 'src/components/agGridComponent/cellOperate';
import { ColDefCustom, default as AgGridVueCustomTsx } from 'src/components/agGridCustom/agGridVueCustomTsx';
import CompareNoticeApi, { CompareNoticeDOI } from '../api/compareNoticeApi';
import ListPageService from 'src/types/ListPage';
import override from 'src/dectorators/override';
import { QueryFormVOI } from 'src/components/queryForm/queryForm';
import EnumCompareStatus from 'src/enums/enumCompareStatus';
import CommonSelect from 'src/components/SelectCustom/commonSelect';
import { DateTimeUtil } from 'src/util/dateTimeUtil';
import Input from 'src/types/iview/Input';
import alertOperateCompareNoticeModal from '../operateCompareNoticeModal';
import EnumOperates from 'src/enums/enumOperates';
import { IconBtnItem } from 'src/components/iconBtnGroup/iconBtnGroup';
import DatePicker from 'src/types/iview/DatePicker';
import CellRenderTsx from 'src/components/agGridComponent/cellRenderTsx';
import alertViewCompareNoticeModal from '../viewCompareNoticeModal';

export default class CompareNoticeService extends ListPageService {
    ctx: CompareNotice;

    constructor(ctx: CompareNotice) {
        super();
        this.ctx = ctx;
    }

    @override
    createColumns(): ColDefCustom[] {
        let t = this;
        return [
            {
                headerName: '通知单号',
                field: 'inform_number',
                minWidth: 120,
                cellRendererFramework: CellRenderTsx,
                cellRendererFrameworkOpt: {
                    cellRender(h, params) {
                        let data: CompareNoticeDOI.RowDataI = params.data;
                        return (
                            <div
                                class="wqms-cursor wqms-link"
                                on-click={() => {
                                    alertViewCompareNoticeModal( data.id);
                                }}
                            >
                                {data.inform_number}
                            </div>
                        );
                    },
                },
            },
            {
                headerName: '发起人',
                field: 'initiator',
                minWidth: 100,
            },
            {
                headerName: '发起时间',
                field: 'sponsor_datetime',
                minWidth: 170,
            },
            {
                headerName: '对比站点',
                field: 'comparison_site',
                minWidth: 140,
                cellRenderer(params) {
                    let data: CompareNoticeDOI.RowDataI = params.data;
                    data.comparison_site = data.comparison_site||{data:[]}
                    return data.comparison_site.data.map(i=>i.operational_site).join(',')
                },
            },
            {
                headerName: '处理单位',
                field: 'dispose_company',
                minWidth: 100,
            },
            {
                headerName: '状态',
                field: 'status',
                minWidth: 100,
                cellRenderer(params) {
                    let data: CompareNoticeDOI.RowDataI = params.data;
                    return EnumCompareStatus.findId(data.status).getName();
                },
            },
            {
                headerName: '审核人',
                field: 'auditor',
                minWidth: 100,
            },
            {
                headerName: '操作',
                field: 'operate',
                minWidth: 120,
                maxWidth: 120,
                cellRendererFramework: CellOperate,
                cellRendererFrameworkOpt: [
                    {
                        text: '修改',
                        disabled(params) {
                            let data: CompareNoticeDOI.RowDataI = params.data;
                            return data.status!==EnumCompareStatus.Transmit.getId();
                        },
                        async click(params) {
                            let data: CompareNoticeDOI.RowDataI = params.data;
                            let res = await alertOperateCompareNoticeModal(EnumOperates.Update.getName(),data.id);
                            if (res) {
                                t.searchTable();
                            }
                        },
                    },
                    {
                        text: '删除',
                        disabled(params) {
                            let data: CompareNoticeDOI.RowDataI = params.data;
                            return data.status!==EnumCompareStatus.Transmit.getId();
                        },
                        async click(params) {
                            let res = await Toast.confirm();
                            if (!res) {
                                return;
                            }
                            let data: CompareNoticeDOI.RowDataI = params.data;
                            await t.delete([data.id]);
                        },
                    },
                ],
            },
        ];
    }

    @override
    creatQueryForm(): QueryFormVOI.DateItemType[] {
        return [
            {
                component: CommonSelect,
                label: '状态：',
                field: 'status',
                props: { value: null, dataSource: EnumCompareStatus.getList() },
            },
            {
                component: DatePicker,
                label: '发起时间',
                field: 'time',
                width: 300,
                timeType: 'number',
                realField: ['start_time', 'end_time'],
                props: { value: DateTimeUtil.getDayInterval(7), type: 'daterange', format: 'yyyy-MM-dd', placeholder: '请选择时间' },
            },
            {
                component: Input,
                labelWidth: 20,
                label: '',
                field: 'keyword',
                props: { value: '', placeholder: '请输入' },
            },
        ];
    }

    async delete(ids: number[]) {
        let { code } = await CompareNoticeApi.delete({ ids });
        if (code === 0) {
            Toast.success('删除成功');
            this.searchTable();
        }
    }

    @override
    createBtnGroup(): Array<IconBtnItem> {
        let t = this;
        return [
            {
                text: '新增',
                async onClick() {
                    let res = await alertOperateCompareNoticeModal(EnumOperates.Add.getName());
                    if (res) {
                        t.searchTable();
                    }
                },
            },
            {
                text: '删除',
                type: 'info',
                async onClick() {
                    let gridOptions: any = t.ctx.gridOptions;
                    let selectRows: CompareNoticeDOI.RowDataI[] = gridOptions.api.getSelectedRows();
                    if (selectRows.length === 0) {
                        return Toast.warning('请选择要操作的数据');
                    }
                    if(selectRows.some(i=> i.status!==EnumCompareStatus.Transmit.getId())) {
                        return Toast.warning('已确认的数据无法删除！');
                    }
                    let res = await Toast.confirm();
                    if (!res) {
                        return;
                    }
                    let ids: number[] = selectRows.map(item => item.id);
                    await t.delete(ids);
                },
            },
        ];
    }

    @override
    initSearchParams(): void {
        this.ctx.searchParams = this.ctx.queryForm.getQueryObj<CompareNoticeDOI.QueryRowDataParamsI>();
        this.ctx.currentPage = 1;
    }

    @override
    async searchTable() {
        let ctx = this.ctx;
        let ag = this.ctx.$refs.ag as AgGridVueCustomTsx;
        ag.showLoading();
        let { code, data } = await CompareNoticeApi.searchList({
            ...ctx.searchParams,
            page_size: ctx.pageSize,
            page_index: ctx.currentPage,
        });
        ag.hideLoading();

        if (code === 0) {
            ctx.rowData = data.data_info || [];
            ctx.total = data.page_count;
        }
    }
}
